import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import withData from 'components/withData';

import { ClassificationContext } from '.';

class Provider extends React.Component {
	static propTypes = {
		children: PropTypes.node.isRequired,
		response: PropTypes.shape({
			loading: PropTypes.bool,
			data: PropTypes.any,
			refetch: PropTypes.func,
		}),
	};

	state = {
		config: null,
	};

	componentWillReceiveProps(nextProps) {
		const { response } = nextProps;

		if (response.success && !this.props.response.success) {
			this.setState({
				config: response.data,
			});
		}
	}

	render() {
		return (
			<ClassificationContext.Provider
				value={{
					...this.state,
					refetch: this.props.response.refetch,
				}}
			>
				{this.props.children}
			</ClassificationContext.Provider>
		);
	}
}

export const ClassificationContextProvider = withRouter(
	withData('/data-classification/config')(Provider)
);
